export default {
	path: '/user',
	children: [
		{
			path: 'auth',
			name: 'AuthenticatePage',
			component: () => import('../pages/auth.vue'),
			meta: {
				publicOnly: true,
				title: 'user.loginRegister'
			}
		}
	]
}
